<template>
  <v-container fluid>
    <v-row>
      <v-col>
        <v-card>
          <v-toolbar color="secondary" dark>
            <v-toolbar-title>
              <v-icon>mdi-clipboard-text</v-icon>Currency Rates
            </v-toolbar-title>
            <v-spacer></v-spacer>
            <v-toolbar-items class="hidden-sm-and-down">
              <v-btn text @click="formOpen = true">
                <v-icon>mdi-plus</v-icon>Add Currency
              </v-btn>
            </v-toolbar-items>
          </v-toolbar>

          <v-data-table
            :headers="headers"
            :items="items"
            :options.sync="pagination" 
            :server-items-length="totalCount"
          >
            <template v-slot:item.actions="{item}">
              <v-icon small class="mr-2" @click="editItem(item)">mdi-pencil</v-icon>
                <v-icon small @click="deleteItem(item)">mdi-delete</v-icon>
            </template>
          </v-data-table>
        </v-card>
        <model-form
          :item="editedItem"
          :open="formOpen"
          v-on:add="addItem()"
          v-on:cancel="cancelItem()"
          v-on:update="updateItem()"
          ></model-form>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>

import _ from "lodash";
import ModelForm from "./_form";
export default {
  components:{
    ModelForm
  },
  data() {
    return {
      items:[],
      headers: [
        { text: "Pair", value: "key" },
        { text: "Rate", value: "rate", align: "right" },
        { text: "Effective Date", value: "effectiveDate" },
        { text: "Actions", value:"actions" }
      ],
      pagination: { itemsPerPage: 10 },
      formOpen: false,
      editedItem: null,
      totalCount: null
    };
  },
  mounted: function() {
    this.getLists();
  },
  watch: {
    pagination: {
      handler: _.debounce(function() {
        this.getLists();
      }, 100)
    }
  },
  methods: {
    getLists() {
      this.$store.dispatch("currencyRates/list", {
        pagination: this.pagination
      })
      .then(({rates}) => {
        this.items = rates.data
        this.totalCount = rates.total
      });
    },
    
    addItem() {
      this.formOpen = false;
      this.editedItem = null;
      this.getLists();
    },
    updateItem() {
      this.formOpen = false;
      this.editedItem = null;
      this.getLists();
    },
    cancelItem() {
      this.formOpen = false;
      this.editedItem = null;
    },
    editItem(item) {
      this.editedItem = Object.assign({}, item);
      this.formOpen = true;
    },
    deleteItem(item) {
      confirm("Are you sure you want to delete this item?") &&
        this.$store
          .dispatch("currencyRates/delete", {
            model: item
          })
          .then(() => {
            this.getLists();
          });
    }
  }
};
</script>
w